<script>
import { required } from "vuelidate/lib/validators";
import MultiSelect from "vue-multiselect";

import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";

export default {
  page: {
    title: "Hotel Master Data",
  },
  emits: ["submitted", "cancelSubmit"],
  props: {
    currentProps: Object,
  },
  data() {
    return {
      hotels: [],
      iOtSupport: [
        {
          text: "Key Code",
          value: "key_code",
        },
        {
          text: "Mobile Key",
          value: "mobile_key",
        },
        {
          text: "RFID Support",
          value: "is_rfid_support",
        },
      ],
      hotel_master_data_form: {
        hotel_key: null,
        admin_key: null,
        firmware_version: null,
        hotel: null,
        iot_support: [],
      },
      submitted: false,
      isBtnLoading: false,
      isError: false,
      errorMessage: null,
    };
  },
  components: {
    MultiSelect,
  },
  validations: {
    hotel_master_data_form: {
      hotel_key: {
        required,
      },
      admin_key: {
        required,
      },
      hotel: {
        required,
      },
      firmware_version: {
        required,
      },
    },
  },
  mounted() {
    this.getHotels();
  },
  methods: {
    // Method is used to get list of all hotels
    async getHotels() {
      try {
        const response = await UserService.getHotelsList();
        if (response) {
          response.map((item) => {
            this.hotels.push({ text: item.name, value: item.id });
          });
          this.setValue();
        }
      } catch (error) {
        errorHandler(error);
      }
    },
    // Method is used to handle set value
    setValue() {
      if (this.currentProps.isEdit) {
        if (this.currentProps.hotelMasterData.hotel !== null) {
          this.hotel_master_data_form.hotel = this.hotels.find(
            (hotel) =>
              hotel.text == this.currentProps.hotelMasterData.hotel.name
          );
        }
        if (this.currentProps.hotelMasterData.iot_support !== null) {
          Object.keys(this.currentProps.hotelMasterData.iot_support).map(
            (item) => {
              this.hotel_master_data_form.iot_support.push(
                this.iOtSupport.find((data) => data.value == item)
              );
            }
          );
        }
        this.hotel_master_data_form.hotel_key =
          this.currentProps.hotelMasterData.hotel_key;
        this.hotel_master_data_form.admin_key =
          this.currentProps.hotelMasterData.admin_key;
        this.hotel_master_data_form.firmware_version =
          this.currentProps.hotelMasterData.firmware_version;
      }
    },
    // Method is used to add and update gateway data
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let data = {
          mct_key: "973454",
          hotel_key: this.hotel_master_data_form.hotel_key,
          admin_key: this.hotel_master_data_form.admin_key,
          firmware_version: this.hotel_master_data_form.firmware_version,
          hotel: this.hotel_master_data_form.hotel.value,
        };
        if (this.hotel_master_data_form.iot_support.length !== 0) {
          let iot_support = {};
          this.hotel_master_data_form.iot_support.map((item) => {
            iot_support[item.value] = true;
          });
          data = {
            ...data,
            iot_support,
          };
        }
        if (this.currentProps.isEdit == false) {
          UserService.addHotelBasedMasterData(data)
            .then((response) => {
              this.isBtnLoading = false;
              this.submitted = false;
              this.$emit("submitted", { data: response });
              this.isError = false;
            })
            .catch((error) => {
              this.isError = true;
              if (Array.isArray(error.response.data)) {
                error.response.data.map((item) => {
                  this.errorMessage.push(item);
                });
              } else {
                this.errorMessage = error.response.data;
              }
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          UserService.editHotelBasedMasterData(
            this.currentProps.hotelMasterDataId,
            data
          )
            .then((response) => {
              this.$emit("submitted", { data: response, isEdit: true });
              this.isBtnLoading = false;
              this.submitted = false;
              this.isError = false;
            })
            .catch((error) => {
              this.isError = true;
              if (Array.isArray(error.response.data)) {
                error.response.data.map((item) => {
                  this.errorMessage.push(item);
                });
              } else {
                this.errorMessage = error.response.data;
              }
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="col-sm-12">
      <h4>
        {{ currentProps.isEdit ? "Update" : "Add New" }} Hotel Master Data
      </h4>
      <hr />
    </div>
    <b-form @submit.prevent="onSubmit">
      <div class="row">
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="hotel_key"
              >Hotel Key <span class="text-danger">*</span></label
            >
            <b-form-input
              id="hotel_key"
              type="text"
              v-model="hotel_master_data_form.hotel_key"
              autocomplete="off"
              v-mask="'####'"
              :class="{
                'is-invalid':
                  submitted && $v.hotel_master_data_form.hotel_key.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.hotel_master_data_form.hotel_key.required"
                >Hotel Key is required.</span
              >
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="admin_key"
              >Admin Key <span class="text-danger">*</span></label
            >
            <b-form-input
              id="admin_key"
              type="text"
              v-model="hotel_master_data_form.admin_key"
              autocomplete="off"
              v-mask="'#########'"
              :class="{
                'is-invalid':
                  submitted && $v.hotel_master_data_form.admin_key.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.hotel_master_data_form.admin_key.required"
                >Admin Key is required.</span
              >
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="firmware_version"
              >Firmware Version <span class="text-danger">*</span></label
            >
            <b-form-input
              id="firmware_version"
              type="text"
              v-model="hotel_master_data_form.firmware_version"
              autocomplete="off"
              :class="{
                'is-invalid':
                  submitted &&
                  $v.hotel_master_data_form.firmware_version.$error,
              }"
            ></b-form-input>
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.hotel_master_data_form.firmware_version.required"
                >Firmware Version is required.</span
              >
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="mb-3">
            <label for="iot_support">IOT Support </label>
            <MultiSelect
              v-model="hotel_master_data_form.iot_support"
              :options="iOtSupport"
              :show-labels="false"
              placeholder="Select Supported IOT Key"
              track-by="value"
              label="text"
              name="iot_suppport"
              :multiple="true"
            />
          </div>
        </div>
        <div class="col-sm-12">
          <div class="mb-3">
            <label for="hotel">Hotel <span class="text-danger">*</span></label>
            <MultiSelect
              v-model="hotel_master_data_form.hotel"
              :options="hotels"
              :show-labels="false"
              placeholder="Select Hotel"
              track-by="value"
              label="text"
              name="hotels"
              :class="{
                'is-invalid':
                  submitted && $v.hotel_master_data_form.hotel.$error,
              }"
            />
            <div v-if="submitted" class="invalid-feedback">
              <span v-if="!$v.hotel_master_data_form.hotel.required"
                >Hotel is required.</span
              >
            </div>
          </div>
        </div>
        <b-alert v-if="isError" show variant="danger">
          <ul>
            <li v-for="(error, index) in errorMessage" :key="index">
              <span class="text-capitalize">
                {{ index.replaceAll("_", " ") }} </span
              >: {{ error[0].replaceAll("_", " ") }}
            </li>
          </ul>
        </b-alert>
        <hr />
        <div class="col-sm-12">
          <b-button
            class="float-end ms-2"
            variant="outline-primary"
            type="reset"
            @click="$emit('cancelSubmit')"
            >Cancel</b-button
          >

          <b-button
            class="float-end"
            variant="outline-primary"
            type="button"
            @click="onSubmit"
          >
            <i
              v-if="isBtnLoading"
              class="bx bx-loader bx-spin font-size-16 align-middle me-2"
            ></i>
            {{ currentProps.isEdit ? "Update" : "Save" }}
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
